import RECEIVABLES_TABS from './ReceivablesTable.constants';

const RECEIVABLES_TABLE_HEADERS = {
  [RECEIVABLES_TABS.MOVEMENTS]: [
    'rvlName',
    'rvlStatus',
    'rvlAmount',
    'rvlDate',
    'rvlDetail',
  ],
};

export default RECEIVABLES_TABLE_HEADERS;
